<template>
  <span class="help-icon">
    <a
      class="helper-icon"
      aria-label="Help"
      tabindex="0"
      @click.prevent="showModal"
    >
      <slot />
      <i
        class="fas fa-info-circle"
        aria-hidden="true"
      />
    </a>
  </span>
</template>

<script>
export default {
  props: {
    modal: {
      type: String,
      default: 'modal',
    },
  },
  methods: {
    showModal() {
      this.$modal.show(this.modal);
    },
  },
};
</script>

<style scoped lang="scss">
  .help-icon {
    vertical-align: middle;
    display: inline-block;
    height: 1rem;
    margin: 0;
    padding: 0;
    line-height: 0;
    a {
      color: $dark-ben-franklin !important;
      text-decoration: none;
      height: 1rem;
    }
    i {
      vertical-align: middle;
    }
  }
</style>